<template>
  <div id="quaFlow" v-show="dialogVisibleForm">
    <el-dialog v-dialogDrag  :visible.sync="dialogVisibleForm" :title="userInfo.name+' 发起流程'"
      :close-on-click-modal="false" :close-on-press-escape="false" width="1200px" class="dialogQua dialogFormQua">
      <flow-flow :key="updateKey" ref="flowFlow" @isLaunchBtn="isLaunchBtn"></flow-flow>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelHanderForm" size="small">取 消</el-button>
        <el-button  type="primary" @click="addHander()" size="small" v-if="isLaunch">发起审批</el-button >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import quaMange from "@/xgzdService/quaMange-service"
import flowFlow from "@/views/project/quaMange/flowForm.vue"
import { mapState } from "vuex"
export default {
  components: { flowFlow},
  data(){
    return{
      dialogVisibleForm:false,
      isLaunch:false,
      updateKey:0
    }
  },
  computed:{
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo,
      routerParams: (state) => state.projectMg.routerParams,
    }),
    qualitySubmitParam(){
      const json = this.$refs.flowFlow.$refs.businessForm.getFormData();
      return {
        endDate:json.endDate||"",
        processTypeId:this.routerParams.flowDefinitionId,
        processType:this.routerParams.name,
        qualityName:json.title,
        type:this.$route.query.noquaFlow,
        modelId:this.$route.query.modelId,//关联的节点id
        prjId:this.$route.query.prjId,
        enterpriseId:this.enterpriseId,
        modelComponentRelaList:json.modelComponentRelaList
      }
    },
  },
  methods:{
    open(){
      this.dialogVisibleForm=true;
      this.updateKey++;
    },
    isLaunchBtn(val){
      this.isLaunch=val;
    },
    cancelHanderForm(){
      this.dialogVisibleForm=false;
    },
    async addHander(){
      const params=this.$refs.flowFlow.getForm()
      if (!this.$refs.flowFlow.$refs.businessForm.validateFormData())return;
      const {data} = await quaMange.addFlowBusiness(params);//添加流程接口
      const submitparams={
        flowBusinessId:data,
        ...this.qualitySubmitParam
      };
      await quaMange.qualityAdd(submitparams);//添加问题接口
      await this.$success('发起流程成功');
      this.dialogVisibleForm=false;
    },
  }
}
</script>

<style lang="scss">
#quaFlow {
  .dialogFormQua{
    .el-dialog__title{
      font-size: 16px;
      color: #323232;
    }
    .el-dialog__body{
      background: #F4F5FA;
      height: 650px;
      padding:11px 16px 0 16px !important
    }
  }
}

</style>